import { FC, useRef, useState } from 'react'
import TitleAndDesc from '@/components/standard/title-and-desc'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import TagItem from '@/components/standard/tag-item'
import { useMobileDetector } from '@/hooks/use-mobile-detector'

gsap.registerPlugin(useGSAP, ScrollTrigger)

type Section10Type = {
  title: string
  desc: string
  mediaUrl: string
  tagList: Array<{
    title: string
    mediaUrl: string
  }>
  theme?: string
}
const Section10: FC<Section10Type> = ({ title, desc, mediaUrl = '', tagList = [], theme }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)
  const mediaRef = useRef<HTMLDivElement>(null)
  const tagListRef = useRef<HTMLDivElement>(null)
  const isMobile = useMobileDetector()
  const [videoCommand, setVideoCommand] = useState<'PLAY' | 'PAUSE'>('PAUSE')
  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: '#main',
        trigger: containerRef.current,
        start: 'top top',
        end: () => `+=${window.innerHeight * 2}`,
        pin: true,
        pinType: 'fixed',
        scrub: 0.3,
        onEnter: () => setVideoCommand('PLAY'),
        onLeaveBack: () => setVideoCommand('PAUSE'),
      },
    })

    const main = document.querySelector('#main')
    main?.addEventListener('wheel', (e) => {
      const wheelEvent = e as WheelEvent
      const isPinned = tl.scrollTrigger?.isActive
      if (isPinned) {
        main.scrollTop += wheelEvent.deltaY
      }
    })

    tl.fromTo(
      mediaRef.current,
      {
        scale: 1.6,
        opacity: 0.3,
      },
      {
        scale: 1,
        opacity: 1,
      }
    ).fromTo(
      [titleRef.current, tagListRef.current],
      {
        opacity: 0,
      },
      {
        opacity: 1,
      }
    )
    return () => {
      tl.kill()
    }
  })
  return (
    <div
      className={clsx('w-full h-fit', 'py-15 laptop:py-30 overflow-hidden', `pd-theme-${theme}`, 'bg-anti-blk')}
      ref={containerRef}
    >
      <div ref={titleRef}>
        <TitleAndDesc title={title} desc={desc} titleTag="h2" />
      </div>
      <div className={clsx('w-full max-w-300 mx-auto', 'flex flex-col items-center')}>
        <div
          className={clsx('w-full laptop:w-300', 'mb-5')}
          style={{
            aspectRatio: '2/1',
          }}
          ref={mediaRef}
        >
          <PdMedia
            src={mediaUrl}
            mask={false}
            showShadow={false}
            stopAutoplay
            loop={false}
            videoCommand={videoCommand}
          />
        </div>
        {/* <div
          className={clsx(
            'w-full flex gap-3 laptop:gap-x-6',
            'grid grid-cols-2 laptop:grid-cols-4',
            'px-6 laptop:px-0'
          )}
          ref={tagListRef}
        >
          {tagList.map((tag) => (
            <TagItem key={tag.title} {...tag} contentAlign={isMobile ? 'left' : 'center'} />
          ))}
        </div> */}
      </div>
    </div>
  )
}

export default Section10
